module.exports = __webpack_public_path__ + "6417d3ba2d12f3b7c018e2fe8440d3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/DiagnosticsWhite.jpg
// module id = 1293
// module chunks = 0